export default __webpack_public_path__ + "static/pattern-2@2x-d2979c3612949b3e2ef13db7fcbd072e.png";